// Les teintes du certificat (lavande, ciel, pêche, beurre) qui tournent les
// unes dans les autres pendant que le document se prépare.
//
// Deux calques de taches, deux fois plus grands que le cadre, qui tournent
// en sens inverse à des vitesses différentes. L'animation est en CSS pur
// (keyframes `spin` de Tailwind) et non en JavaScript : la génération du PDF
// occupe le navigateur, une animation pilotée par script resterait figée.
const LAYER_A =
    "radial-gradient(circle at 28% 30%, #B8A4FF 0, transparent 34%)," +
    "radial-gradient(circle at 72% 34%, #8CC8FF 0, transparent 32%)," +
    "radial-gradient(circle at 66% 74%, #FFB59A 0, transparent 34%)," +
    "radial-gradient(circle at 30% 70%, #FFE27A 0, transparent 30%)";
const LAYER_B =
    "radial-gradient(circle at 50% 24%, #FFB59A 0, transparent 30%)," +
    "radial-gradient(circle at 76% 58%, #B8A4FF 0, transparent 32%)," +
    "radial-gradient(circle at 26% 54%, #8CC8FF 0, transparent 30%)";

// À poser dans un conteneur relative : il le remplit. `label` n'est lu que
// par les lecteurs d'écran. `progress` (0 à 1) dit où en est la préparation :
// les taches partent du gris et prennent leurs couleurs à mesure qu'elle
// avance. Sans `progress`, elles sont en couleur.
export default function CertificationLoader({ label, progress = 1 }) {
    const gray = 1 - Math.min(Math.max(progress, 0), 1);

    return (
        <div
            role="status"
            className="absolute inset-0 overflow-hidden bg-[#F4F0FF] transition-[filter] duration-700 ease-out dark:bg-[#241D46]"
            style={{ filter: `grayscale(${gray})` }}
        >
            <span
                aria-hidden
                className="absolute -inset-1/2 animate-[spin_7s_linear_infinite] blur-xl will-change-transform motion-reduce:animate-none dark:opacity-60"
                style={{ backgroundImage: LAYER_A }}
            />
            <span
                aria-hidden
                className="absolute -inset-1/2 animate-[spin_11s_linear_infinite] opacity-70 blur-xl will-change-transform [animation-direction:reverse] motion-reduce:animate-none dark:opacity-40"
                style={{ backgroundImage: LAYER_B }}
            />
            {label && <span className="sr-only">{label}</span>}
        </div>
    );
}
